import React from 'react';
import {connect} from 'react-redux'
import DefaultDeviseTemplateContainer from '../DefaultDeviseTemplateContainer'
import ParentalStatusSurveyForm from './ParentalStatusSurveyForm'
import {
    editParentalStatusSurvey,
    updateParentalStatusSurvey
} from '../../actions'
import { Button, message } from 'antd'

import {history} from "../../router/history";

class ParentalStatusSurveyContaioner extends React.Component {

    componentWillMount() {
        this.props.editParentalStatusSurvey()
    }


    render() {
        return (
            <div>
                <DefaultDeviseTemplateContainer
                    title='學生暨家長身份調查表'
                    menuButton={this.menuButton()}
                    htmlBody={<ParentalStatusSurveyForm onSubmit={this.onSubmit} isLocked={this.props.isLocked}></ParentalStatusSurveyForm>}
                />
            </div>
        )

    }

    onSubmit = (value) => {
        if (this.props.isLocked) {
            message.warning('此表單已鎖定，無法修改資料');
            return;
        }
        this.props.updateParentalStatusSurvey(value)
    }

    menuButton() {
        return (
            <Button onClick={() => this.goIndex()}>
                返回
            </Button>
        )
    }

    goIndex() {
        history.push('/devise_dashboard')
    }

}

const mapStateToProps = (state) => {
    const parentalData = state.getIn(['ParentalStatusSurveyReducers', 'data']);
    const safeParentalData = parentalData && parentalData.toJS ? parentalData.toJS() : (parentalData || {});

    return {
        isLocked: !!safeParentalData.ques_check,
    }
}

const mapDispatchToPorps = (dispatch) => ({
    editParentalStatusSurvey: () => (
        dispatch(editParentalStatusSurvey(dispatch))
    ),
    updateParentalStatusSurvey: (payload) => (
        dispatch(updateParentalStatusSurvey(dispatch,payload))
    ),
})

export default connect(mapStateToProps, mapDispatchToPorps)(ParentalStatusSurveyContaioner)



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ParentalStatusSurveyContaioner/ParentalStatusSurveyContaioner.jsx